export const linkReqIdRegex = /Req:\s*(\d+)/;
export const linkIdRegex = /linkId:\s*(\d+)/;
export const linkUuidRegex = /linkUuid:\s*(\d+)/;
export const paragraphOutIdRegex = /paragraphOutId:\s*(\d+)/;
export const delivIdRegex = /delivId:\s*(\d+)/;
export const uuidRegex = /uuid:\s*([^|]*[^|\s])/;
export const newLineRegex = /[\f\r]/g;
export const mustHave = ["paragraphOutId:", "uuid", "linkUuid", "delivId", "linkId:"];
export const textFromFirstDigit = /\d.*$/;
// eslint-disable-next-line no-control-regex
export const spaceRegex = /[\u000b\r]/g;
